import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const JobListApi = createApi({
  reducerPath: "JobListApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_HOST }),
  endpoints: (builder) => ({
    getJobList: builder.mutation({
      query: (data) => ({
        url: "get/jobs/listing",
        method: "POST",
        body: data,
      }),
    }),
    getJob: builder.query({
      query: (id) => ({
        url: "get/jobs/" + id,
      }),
    }),
  }),
});

export const { useGetJobListMutation, useGetJobQuery } = JobListApi;
